module.exports = __webpack_public_path__ + "static/media/9.2df29f40.svg";